import React, { useState } from 'react';
import useAuth from './hooks/useAuth';
import Login from './components/layout/Login';
import Header from './components/layout/Header';
import Dashboard from './components/dashboard/Dashboard';
import SettingsModal from './components/modals/SettingsModal';

import { AuthProvider } from './context/AuthContext';
import { CategoryProvider } from './context/CategoryContext';
import { TransactionProvider } from './context/TransactionContext';
import { ToastProvider } from './context/ToastContext';

const AppContent = () => {
  const { isAuthenticated } = useAuth();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <div className="min-h-screen bg-neutral-50 text-neutral-800 antialiased selection:bg-primary-500 selection:text-white">
      {/* Sticky desktop header */}
      <Header onSettingsClick={() => setIsSettingsOpen(true)} />

      {/* Main container */}
      <main className="container mx-auto px-4 py-4 md:py-6 max-w-6xl">
        <Dashboard onSettingsClick={() => setIsSettingsOpen(true)} />
      </main>

      {/* Settings Modal */}
      {isSettingsOpen && (
        <SettingsModal onClose={() => setIsSettingsOpen(false)} />
      )}
    </div>
  );
};

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <CategoryProvider>
          <TransactionProvider>
            <AppContent />
          </TransactionProvider>
        </CategoryProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
